import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';

interface TelegramInitDataEntry {
  key: string;
  value: string;
}

@Component({
  selector: 'app-about-page',
  standalone: true,
  imports: [CommonModule, MatCardModule],
  templateUrl: './about-page.component.html',
  styleUrl: './about-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AboutPageComponent {
  @Input() buildVersion = 'unknown';
  @Input() backendVersion = 'unknown';
  @Input() debugVisible = false;
  @Input() isTelegramWebApp = false;
  @Input() hasTelegramInitData = false;
  @Input() telegramVerifyState = 'idle';
  @Input() telegramVerifyMessage = '';
  @Input() telegramInitDataRaw = '';
  @Input() telegramInitDataEntries: TelegramInitDataEntry[] = [];
  @Input() telegramInitDataUnsafeDebug = '';
  @Input() telegramVerifyResponseDebug = '';
  @Input() telegramVerifyErrorDebug = '';
  @Input() debugLocationHref = '';
  @Input() debugLocationSearch = '';
  @Input() debugLocationHash = '';
}
